export default function Footer() {
  return (
    <footer className="bg-teal-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">厦门中航嘉禾</h3>
            <p className="text-teal-200 text-sm">
              您值得信赖的全球物流解决方案合作伙伴
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4">服务项目</h4>
            <ul className="space-y-2 text-sm text-teal-200">
              <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">空运服务</a></li>
              <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">海运服务</a></li>
              <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">陆运服务</a></li>
              <li><a href="#services" className="hover:text-white transition-colors cursor-pointer">仓储服务</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">关于公司</h4>
            <ul className="space-y-2 text-sm text-teal-200">
              <li><a href="#about" className="hover:text-white transition-colors cursor-pointer">关于我们</a></li>
              <li><a href="#network" className="hover:text-white transition-colors cursor-pointer">全球网络</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">联系我们</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-teal-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-teal-300">
          <p>&copy; 2024 厦门中航嘉禾 版权所有</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-white transition-colors cursor-pointer mt-4 md:mt-0">Powered by Readdy</a>
        </div>
      </div>
    </footer>
  );
}